    data = {
        "distributors": [
          {
            "company": "1095 Supply ",
            "site": "https://www.instagram.com/gregostattoos/",
            "address": "7203 SW 8th St, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Miami, FL 33144",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.7631282,
              -80.3150923
            ],
            "instagram": "https://www.instagram.com/gregostattoos/"
          },
          {
            "company": "1oz Tattoo Shop",
            "site": "https://1oz.kz/",
            "address": "Zhibek Zholy 106 Almaty, Kazakhstan",
            "zip": "",
            "region": "Asia",
            "country": "Kazakhstan",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/kazakhstan.svg?v=1727758542",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              43.2619211,
              76.9430494
            ],
            "instagram": "https://www.instagram.com/1oz.kz/"
          },
          {
            "company": "5th Avenue Studio Supply",
            "site": "https://www.5-ave.com/",
            "address": "2212 S W Temple St #48",
            "zip": "84115",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "South Salt Lake, UT",
            "name": "",
            "playvideo": "",
            "latLng": [
              40.7230165,
              -111.8988009
            ],
            "instagram": "https://www.instagram.com/5thavesupplies/"
          },
          {
            "company": "Quinto Elemento",
            "site": "https://quintoelementovap.com/collections/tattoo",
            "address": "Cra. 48, Cl. 61 Sur # 115",
            "zip": "",
            "region": "South America",
            "country": "Colombia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/co.svg",
            "state": "Antioquia",
            "name": "",
            "playvideo": "",
            "latLng": [
              6.1821862,
              -75.5890362
            ]
          },
          {
            "company": "A Stroke of Genius",
            "site": "https://astrokeofgeniustattoos.com/",
            "address": "1621 SE 3rd Ct",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Deerfield Beach, FL 33441",
            "name": "",
            "playvideo": "",
            "latLng": [
              26.3686955,
              -80.0895393
            ]
          },
          {
            "company": "Acute Tattoo Supply ",
            "site": "https://s.shopee.tw/4q1PVFb9Y6",
            "address": "No.11 Dade St. North Dust, Taichung",
            "zip": "",
            "region": "Asia",
            "country": "Taiwan",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/taiwain.svg?v=1727757662",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              24.1657957,
              120.5979362
            ],
            "instagram": "https://www.instagram.com/acutetattoo/?hl=en"
          },
          {
            "company": "Akasha Tattoo Supply",
            "site": "",
            "address": "4326 S Semoran Blvd ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Orlando, FL 32822",
            "name": "",
            "playvideo": "",
            "latLng": [
              28.5000205,
              -81.3160202
            ],
            "instagram": "https://www.instagram.com/akashatattoosupply/"
          },
          {
            "company": "Akasha Tattoo Supply PR",
            "site": "http://www.akashatattoosupplies.com/",
            "address": "82 Calle Aquamarina, Caguas, 00725",
            "zip": "",
            "region": "Caribbean Islands",
            "country": "Puerto Rico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/pr.svg?v=1722500073",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              18.2484477,
              -66.0381514
            ],
            "instagram": "https://www.instagram.com/akashatattoosupply/"
          },
          {
            "company": "All American Tattoo ",
            "site": "https://aatattoosupply.com/",
            "address": "287 Lakewood Dr, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Greenville, Sourth Carolina 29607",
            "name": "",
            "playvideo": "",
            "latLng": [
              34.8039136,
              -82.4322934
            ],
            "instagram": "https://www.instagram.com/allamericantattoosupply/"
          },
          {
            "company": "Allegory Europe",
            "site": "https://allegoryink.eu/",
            "address": "Av. De la Riera, nave 2 08960",
            "zip": "",
            "region": "Europe",
            "country": "Spain",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/spa.svg",
            "state": "Sant Just Desvern, Barcelona",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.3820798,
              2.0564697
            ],
            "instagram": "https://www.instagram.com/allegoryink"
          },
          {
            "company": "Alliance Tattoo Supply ",
            "site": "https://alliancetattoosupply.com/",
            "address": "5925 School Ave Henrico, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Virginia 23228",
            "name": "",
            "playvideo": "",
            "latLng": [
              37.6087968,
              -77.4957214
            ],
            "instagram": "https://www.instagram.com/alliancetattoosupply/?hl=en"
          },
          {
            "company": "Altered Ego Tattoos ",
            "site": "",
            "address": "8521 Fort Smallwood Rd, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Pasadena, Maryland 21122",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.5948147,
              -75.9797065
            ]
          },
          {
            "company": "Artist Lab Tattoo Supply ",
            "site": "https://artistlabtattoosupply.com/",
            "address": "605 S Sherman St, STE i, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Richardson, Texas 75081",
            "name": "",
            "playvideo": "",
            "latLng": [
              32.9443205,
              -96.7388483
            ],
            "instagram": "https://www.instagram.com/artist_lab_tattoo_supply/"
          },
          {
            "company": "Asia Tattoo Supply",
            "site": "http://www.asiatattoosupply.com/",
            "address": "5 Banda St, #03-56",
            "zip": "",
            "region": "Asia",
            "country": "Singapore",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/singapore.svg?v=1727758909",
            "state": "Singapore",
            "name": "",
            "playvideo": "",
            "latLng": [
              1.2812721,
              103.8408101
            ],
            "instagram": "https://www.instagram.com/asiatattoosupply/?hl=en"
          },
          {
            "company": "Barber DTS",
            "site": "https://www.barberdts.com/uk/",
            "address": "Unit 25 Shortwood Ct",
            "zip": "",
            "region": "Europe",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg?v=1722500404",
            "state": "Birdwell, Barnsley S74 9LH",
            "name": "",
            "playvideo": "",
            "latLng": [
              53.5084794,
              -1.4667038
            ],
            "instagram": "https://www.instagram.com/barber_dts/"
          },
          {
            "company": "Beacon Tattoo Supply",
            "site": "https://beacontattoosupply.com/",
            "address": "1750 S Rainbow Blvd Ste 18 ",
            "zip": "89146",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Las Vegas, Nevada",
            "name": "",
            "playvideo": "",
            "latLng": [
              36.1523556,
              -115.2450119
            ],
            "instagram": "https://www.instagram.com/beacontattoosupply/?hl=en"
          },
          {
            "company": "Bicknee Supply Company ",
            "site": "https://bicknee.com/",
            "address": "1928 Jackson Pike",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Bidwell, Ohio 45614",
            "name": "",
            "playvideo": "",
            "latLng": [
              38.8433642,
              -82.2720769
            ],
            "instagram": "https://www.instagram.com/bicknee/"
          },
          {
            "company": "Bicknee Supply Company",
            "site": "https://bicknee.com/",
            "address": "3982 Alum Creek Dr",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Columbus, OH 43207",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.8872169,
              -82.9324704
            ],
            "instagram": "https://www.instagram.com/bicknee/"
          },
          {
            "company": "Black Angel Tattoo Supply Shop",
            "site": "",
            "address": "112 imelda avenue.. 2nd flr The Avenue Complex Along, Felix Ave, Cainta, 1900 Rizal",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              14.5902515,
              121.1114627
            ]
          },
          {
            "company": "Blackwork Worldwide LLC",
            "site": "https://blackworksupply.com/",
            "address": "2615 Port Industrial Dr Unit 401 ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Jacksonville, FL",
            "name": "",
            "playvideo": "",
            "latLng": [
              30.4256309,
              -81.5804462
            ],
            "instagram": "https://www.instagram.com/blackwork_supply/"
          },
          {
            "company": "Blue Tattoo Supply",
            "site": "",
            "address": "Cartago Province",
            "zip": "",
            "region": "Central America",
            "country": "Costa Rica",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/cr.svg?v=1727386711",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              9.8163313,
              -84.029689
            ],
            "instagram": "https://www.instagram.com/bluesupply.cr/"
          },
          {
            "company": "Brett Stewart Tattoo Supplies",
            "site": "https://www.bstattoo.com.au/",
            "address": "20-22 Rodney Road, Geelong",
            "zip": "",
            "region": "Australia",
            "country": "Australia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/aus.png?v=1739821511",
            "state": "Victoria",
            "name": "",
            "playvideo": "",
            "latLng": [
              -38.0993699,
              144.3454138
            ],
            "instagram": "https://www.instagram.com/bstattoosupplies"
          },
          {
            "company": "BTS Tattoo Supplies",
            "site": "",
            "address": "Rua costa cabral 2577",
            "zip": "",
            "region": "Europe",
            "country": "Portugal",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/portugal.png?v=1742249016",
            "state": "Porto",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.1783854,
              -8.5870317
            ],
            "instagram": "https://www.instagram.com/bts_tattoo_supplies/?hl=en"
          },
          {
            "company": "BugaTattoo",
            "site": "",
            "address": "Cra. 15 #7-2 a 7-120, Guadalajara de Buga",
            "zip": "",
            "region": "South America",
            "country": "Colombia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/co.svg?v=1722505025",
            "state": "Valle del Cauca",
            "name": "",
            "playvideo": "",
            "latLng": [
              7.1378293,
              -73.1346371
            ],
            "instagram": "https://www.instagram.com/bugatattooshop"
          },
          {
            "company": "Canada Tattoo Supply",
            "site": "https://canadatattoosupply.com/",
            "address": "1010 Polytek St #24, ",
            "zip": "K1J 9J1",
            "region": "Canada",
            "country": "Canada",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ca.svg",
            "state": "Gloucester, Ontario K1J 9H9",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.4631088,
              -80.4351122
            ],
            "instagram": "https://www.instagram.com/canadatattoosupply/"
          },
          {
            "company": "Cancerbero Tattoo Supplies",
            "site": "https://www.cancerberotattoo.com/index.php",
            "address": "BAI Jos\u00e9 Ingenieros Provincia de Buenos Aires AR, Eduardo Comesa\u00f1a 2703, B1703,",
            "zip": "",
            "region": "South America",
            "country": "Argentina",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ar.svg?v=1727386791",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              -34.6205552,
              -58.5378453
            ],
            "instagram": "https://www.instagram.com/cancerberotattoosupplies/"
          },
          {
            "company": "Chicos Marked 4 Life",
            "site": "https://www.instagram.com/chicom4l/?hl=en",
            "address": "15166 SW 56th St, ",
            "zip": "33185",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Miami, FL 33185",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.7127869,
              -80.4431243
            ],
            "instagram": "https://www.instagram.com/chicom4l/?hl=en"
          },
          {
            "company": "Dark Side Tattoo Supply",
            "site": "https://www.darksidesupply.com/",
            "address": "9924 N 2nd St",
            "zip": "61115",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Machesney Park, Illinois 61115",
            "name": "",
            "playvideo": "",
            "latLng": [
              42.3653407,
              -89.0423429
            ],
            "instagram": "https://www.instagram.com/darksidetattoosupplyinc/"
          },
          {
            "company": "Dermaglo Tattoo Supplies LTD",
            "site": "https://dermaglotattoosupplies.com/",
            "address": "15 Union street Blyth",
            "zip": "",
            "region": "Europe",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg",
            "state": "Northumberland",
            "name": "",
            "playvideo": "",
            "latLng": [
              55.1249042,
              -1.5093857
            ],
            "instagram": "https://www.instagram.com/dermaglotattoosuppliesuk/"
          },
          {
            "company": "Dermasoft Inc",
            "site": "https://dermasofttattoo.com/",
            "address": "1476 E Valencia Dr",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Fullerton, California 92831",
            "name": "",
            "playvideo": "",
            "latLng": [
              33.8893845,
              -117.9657616
            ],
            "instagram": "https://www.instagram.com/dermasofttattoo/"
          },
          {
            "company": "DH Tattoo Supply ",
            "site": "https://www.dhts.cc/",
            "address": "5F., No. 48, Zhongzhou St., Taoyuan Dist.,",
            "zip": "",
            "region": "Asia",
            "country": "Taiwan",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/taiwain.svg?v=1727757662",
            "state": "Taoyuan City 330756",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.0107997,
              121.1812258
            ],
            "instagram": "https://www.instagram.com/dhtattoosupply/"
          },
          {
            "company": "Dragon Tattoo Supply",
            "site": "https://www.dovmemalzemesi.net/",
            "address": "Hac\u0131mimi Mahallesi Kemeralt\u0131 Caddesi No:35/A Tophane-Beyo\u011flu",
            "zip": "",
            "region": "Asia",
            "country": "Turkey",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/tu.svg?v=1723188226",
            "state": "Istanbul",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.0263335,
              28.9763562
            ],
            "instagram": "https://www.instagram.com/dragontattoosupply"
          },
          {
            "company": "Electrum Supply",
            "site": "https://electrumsupply.com/",
            "address": "24266 Co Rd 45, ",
            "zip": "46516",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Elkhart, Indiana 46516",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.6458932,
              -85.9341275
            ],
            "instagram": "https://www.instagram.com/electrumsupply/"
          },
          {
            "company": "Expresi\u00f3n Tattoo & Supply",
            "site": "",
            "address": "Providencia Almirante pastene 244 Oficina 605 B San bernardo Eyzaguirre 579 Galer\u00eda puertas del sol-213",
            "zip": "",
            "region": "South America",
            "country": "Chile",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/chile-flag.svg?v=1723524371",
            "state": "Providencia",
            "name": "",
            "playvideo": "",
            "latLng": [
              -33.4267089,
              -70.623556
            ],
            "instagram": "https://www.instagram.com/expresion_tattoosupply/?hl=en"
          },
          {
            "company": "FK Irons",
            "site": "https://www.fkirons.com/",
            "address": "1771 NW 79th Ave #1112,",
            "zip": "33126",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Doral, FL 33126",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.7913453,
              -80.3243846
            ],
            "instagram": "https://www.instagram.com/fkirons/"
          },
          {
            "company": "FYT Tattoo Supplies ",
            "site": "https://fytsupplies.com/",
            "address": "59-05 39th Ave ",
            "zip": "11377",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Queens, NY 11377",
            "name": "",
            "playvideo": "",
            "latLng": [
              40.7478133,
              -73.9066868
            ],
            "instagram": "https://www.instagram.com/fytsupplies/"
          },
          {
            "company": "FYT Tattoo Supplies ",
            "site": "https://fytsupplies.com/",
            "address": "300 Steelcase Rd W Unit 16",
            "zip": "11377",
            "region": "Canada",
            "country": "Canada",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ca.svg",
            "state": "Markham, Ontario L3R 2W2",
            "name": "",
            "playvideo": "",
            "latLng": [
              43.82237,
              -79.3613549
            ],
            "instagram": "https://www.instagram.com/fytsupplies/"
          },
          {
            "company": "FYT Tattoo Supplies ",
            "site": "https://fytsupplies.com/",
            "address": "2093 Rue Parthenais, ",
            "zip": "11377",
            "region": "Canada",
            "country": "Canada",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ca.svg",
            "state": "Montréal, QC H2K 4P8",
            "name": "",
            "playvideo": "",
            "latLng": [
              45.5302342,
              -73.5600817
            ],
            "instagram": "https://www.instagram.com/fytsupplies/"
          },
          {
            "company": "FYT Tattoo Supplies ",
            "site": "https://fytsupplies.com/",
            "address": "5, Jln Sagu 17, Taman Daya, 81100 Johor Bahru, Johor Darul Ta'zim",
            "zip": "11377",
            "region": "USA",
            "country": "Malaysia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Malaysia",
            "name": "",
            "playvideo": "",
            "latLng": [
              1.5455035,
              103.761961
            ],
            "instagram": "https://www.instagram.com/fytsupplies/"
          },
          {
            "company": "Gyaa Tattoo Supply",
            "site": "https://gyaatattoosupply.com/",
            "address": "3150 SE 7th Pl",
            "zip": "33033",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Homestead, FL",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.4631088,
              -80.4351122
            ],
            "instagram": "https://www.instagram.com/gyaa_tattoosupply?igsh=emJzNjRrN2pjcjdr&utm_source=qr"
          },
          {
            "company": "Helios Tattoo Supply",
            "site": "https://www.heliostattoo.com/default.asp",
            "address": "3180 Express Dr S AB, ",
            "zip": "11749",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Islandia, New York 11749dsY",
            "name": "",
            "playvideo": "",
            "latLng": [
              40.8075712,
              -73.1853635
            ],
            "instagram": "https://www.instagram.com/HeliosTattoo"
          },
          {
            "company": "Incienso",
            "site": "https://www.inciensoprshop.com/",
            "address": "1085 Av. Miramar",
            "zip": "612",
            "region": "Caribbean Islands",
            "country": "Puerto Rico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/pr.svg?v=1722500073",
            "state": "Miramar, Arecibo",
            "name": "",
            "playvideo": "",
            "latLng": [
              18.4738174,
              -66.7465563
            ],
            "instagram": "https://www.instagram.com/inciensopr/"
          },
          {
            "company": "Industrias Warlock",
            "site": "https://warlockstore.com/",
            "address": "Dg. 60 Sur # 75 c 16, Cdad. Bol\u00edvar", 
            "zip": "",
            "region": "South America",
            "country": "Colombia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/co.svg?v=1722505025",
            "state": "Bogot\u00e1, Cundinamarca",
            "name": "",
            "playvideo": "",
            "latLng": [
              4.5918897,
              -74.1795679
            ],
            "instagram": "https://www.instagram.com/industriaswarlock/?hl=en"
          },
          {
            "company": "Inkden Tattoo Supply",
            "site": "",
            "address": "Sitio Pook, Lutucan 1 Sariaya, Quezon",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              13.9216795,
              118.8646035
            ],
            "instagram": "https://www.instagram.com/inkdentattoo"
          },
          {
            "company": "INKSpire T.S. Japan",
            "site": "https://www.instagram.com/inkspire.japan/?hl=en",
            "address": "8th Floor Hankyu Senri Chuo Buildimg,1-4-1 Shinsenri Higashi-machi,Toyonaka-shi,",
            "zip": "",
            "region": "Asia",
            "country": "Japan",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/jp.svg",
            "state": "Osaka",
            "name": "",
            "playvideo": "",
            "latLng": [
              34.8082504,
              135.4976388
            ],
            "instagram": "https://www.instagram.com/inkspire.japan/"
          },
          {
            "company": "INKSpire T.S. Philippines",
            "site": "https://inkspire.ph/",
            "address": "Banilad (LM Dormitel / Ministop, Gov. M. Cuenco Ave,",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              10.349549,
              123.910575
            ],
            "instagram": "https://www.instagram.com/inkspire_philippines/"
          },
          {
            "company": "INKSpire T.S. Taiwan",
            "site": "https://www.instagram.com/ink_t.s._taiwan_digital_ink/?hl=en",
            "address": "4F., No. 9, Zhong'an St., Xinzhuang Dist.",
            "zip": "",
            "region": "Asia",
            "country": "Taiwan",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/taiwain.svg?v=1727757662",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.0457608,
              121.4504617
            ],
            "instagram": "https://www.instagram.com/inkspire.taiwan/"
          },
          {
            "company": "JL Tattoo & Supplies",
            "site": "",
            "address": "2nd Floor, Unit 2S, Josephine Business Properties Corporation Mataas na Lupa, Ayala Hwy, Lipa, 4217 ",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Batangas, Philippines",
            "name": "",
            "playvideo": "",
            "latLng": [
              13.9422085,
              121.1496162
            ],
            "instagram": "Inactive Instagram"
          },
          {
            "company": "Keystone Tattoo",
            "site": "https://keystonetattoosupply.com/",
            "address": "833 Lincoln Ave Unit 5 West Chester",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Pennsylvania 19380",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.9720652,
              -75.5959738
            ],
            "instagram": "https://www.instagram.com/keystonetattoosupply/"
          },
          {
            "company": "Killer Ink Limited",
            "site": "https://www.killerinktattoo.co.uk/",
            "address": "Venture Point West, 54 Evans Rd, Speke",
            "zip": "",
            "region": "Europe",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg",
            "state": "Liverpool L24 9PB",
            "name": "",
            "playvideo": "",
            "latLng": [
              53.3521948,
              -2.857318
            ],
            "instagram": "https://www.instagram.com/killerinktattoo/"
          },
          {
            "company": "Kingpin Tattoo Supply",
            "site": "http://kingpintattoosupply.com",
            "address": "9715 International Ct N",
            "zip": "33716",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "St. Petersburg, FL",
            "name": "",
            "playvideo": "",
            "latLng": [
              27.8601386,
              -82.6557813
            ],
            "instagram": "https://www.instagram.com/kingpintattoosupply/"
          },
          {
            "company": "KINGPIN TATTOO SUPPLY",
            "site": "https://www.kingpintattoosupply.com/",
            "address": "9330 United Drive Suite 4-150 ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Austin, TX 78758",
            "name": "",
            "playvideo": "",
            "latLng": [
              30.3797695,
              -97.7343154
            ],
            "instagram": "https://www.instagram.com/kingpintattoosupply/"
          },
          {
            "company": "La Barberia Tattoo Shop",
            "site": "https://labarberiatattooshop.com/",
            "address": "Edificio 15, V\u00eda Argentina, Panam\u00e1, Provincia de Panam\u00e1",
            "zip": "",
            "region": "Central America",
            "country": "Panama",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/pa.svg?v=1722505347",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              8.9887567,
              -79.5309949
            ],
            "instagram": "https://www.instagram.com/labarberiatattoopty"
          },
          {
            "company": "Legacy Tattoo Supply",
            "site": "https://www.legacytattooandsupply.com/shop",
            "address": "5926 Hillside Ave, ",
            "zip": "",
            "region": "Canada",
            "country": "Canada",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ca.svg",
            "state": "Halifax, NS B3K 2S5",
            "name": "",
            "playvideo": "",
            "latLng": [
              44.6657924,
              -63.6135977
            ],
            "instagram": "https://www.instagram.com/legacysupplies/"
          },
          {
            "company": "Makuza Tattoo Supply Spa",
            "site": "https://makuza.cl/",
            "address": "Gral. Holley 148, 7510701 Providencia",
            "zip": "",
            "region": "South America",
            "country": "Chile",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/chile-flag.svg?v=1723524371",
            "state": "Regi\u00f3n Metropolitana",
            "name": "",
            "playvideo": "",
            "latLng": [
              -33.4198642,
              -70.6121452
            ],
            "instagram": "https://www.instagram.com/makuzatattoosupply/?hl=en"
          },
          {
            "company": "Maple Tattoo Supply",
            "site": "https://www.mapletattoosupply.com/",
            "address": "106 Martin Ross Ave",
            "zip": "",
            "region": "Canada",
            "country": "Canada",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ca.svg",
            "state": "North York, ON M3J 2L4",
            "name": "",
            "playvideo": "",
            "latLng": [
              43.7737931,
              -79.480304
            ],
            "instagram": "https://www.instagram.com/mapletattoosupply/"
          },
          {
            "company": "Melbourne Tattoo Supply",
            "site": "https://melbournetattoosupplies.com/",
            "address": "2/44 Mahoneys Road, Thomastown 3074",
            "zip": "",
            "region": "Australia",
            "country": "Australia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/aus.png?v=1739821511",
            "state": "Thomastown",
            "name": "",
            "playvideo": "",
            "latLng": [
              -37.9855703,
              145.136036
            ],
            "instagram": "https://www.instagram.com/melbournetattoosupplies"
          },
          {
            "company": "Miami Tattoo Supplies",
            "site": "https://www.miamitattoosupplies.com/",
            "address": "2115 Hollywood Blvd. ",
            "zip": "33020",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Hollywood, FL 33020",
            "name": "",
            "playvideo": "",
            "latLng": [
              26.0117194,
              -80.1523074
            ],
            "instagram": "https://www.instagram.com/miamitattoosupplies/"
          },
          {
            "company": "Mosquito Tattoo Supply",
            "site": "https://mosquitotattoosupply.com/",
            "address": "6824 Albemarle Rd B ",
            "zip": "28212",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Charlotte, NC 28212",
            "name": "",
            "playvideo": "",
            "latLng": [
              35.20194,
              -80.7301349
            ],
            "instagram": "https://www.instagram.com/mosquitotattoosupply/"
          },
          {
            "company": "Mrt Tattoo Supply",
            "site": "https://mrttattoo.com/",
            "address": "Dubai",
            "zip": "",
            "region": "Asia",
            "country": "United Arab Emirates",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/dubai_28c8e2f6-1581-4546-987d-3a8e791852ae.png?v=1739821625",
            "state": " ",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.0762789,
              44.6798594
            ]
          },
          {
            "company": "Needle Supply Tattoo Supplies",
            "site": "https://needlesupply.com/",
            "address": "560 N Bullard Ave #53 ",
            "zip": "85338",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Goodyear, AZ 85338",
            "name": "",
            "playvideo": "",
            "latLng": [
              33.4525267,
              -112.380692
            ],
            "instagram": "https://www.instagram.com/needlesupply"
          },
          {
            "company": "Nuclear Tattoo Supply",
            "site": "https://store.nucleartattoo.com/",
            "address": "11808 Burke St.  ",
            "zip": "90670",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Santa Fe Springs, California 90670",
            "name": "",
            "playvideo": "",
            "latLng": [
              33.9623919,
              -118.0680029
            ],
            "instagram": "https://www.instagram.com/nucleartattoosupply/?hl=en"
          },
          {
            "company": "Osus Tattoo Supplies",
            "site": "",
            "address": "Garcia Subdivision, 11456 Atis Street, San Antonio, Bi\u00f1an, 4024 Laguna",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              14.3308525,
              121.083523
            ],
            "instagram": "https://www.instagram.com/osustattoosuppliesshop/"
          },
          {
            "company": "PainfulPleasures",
            "site": "https://www.painfulpleasures.com/",
            "address": "7410 Coca Cola Dr STE 108 ",
            "zip": "21076",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Hanover, Maryland 21076",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.1889041,
              -76.7284812
            ],
            "instagram": "https://www.instagram.com/painfulpleasures"
          },
          {
            "company": "Perfect Shadow Tattoo And Supplies",
            "site": "",
            "address": "Rabaya street, daruhan drive,kimba, Talisay",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Cebu, Philippines",
            "name": "",
            "playvideo": "",
            "latLng": [
              10.2547766,
              123.8540938
            ]
          },
          {
            "company": "Por Vida Tattoo Supply",
            "site": "https://www.porvidatattoosupply.com/",
            "address": "500 4th St SW",
            "zip": "87102",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Albuquerque, New Mexico",
            "name": "",
            "playvideo": "",
            "latLng": [
              35.0803274,
              -106.6547782
            ],
            "instagram": "https://www.instagram.com/porvidatattoosupply/"
          },
          {
            "company": "Pro- Arts Tattoo & Piercing Supplies",
            "site": "https://www.pro-arts.com/es/",
            "address": "Carrer de Sant Pere M\u00e9s Alt, 23, Ciutat Vella, 08003",
            "zip": "",
            "region": "Europe",
            "country": "Spain",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/spa.svg",
            "state": "Barcelona",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.3881582,
              2.1734693
            ],
            "instagram": "https://www.instagram.com/proarts_bcn/"
          },
          {
            "company": "Pulse Tattoo Supply",
            "site": "https://pulsetattoo.com/",
            "address": "485 New Park Ave suite k",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "West Hartford, Connecticut 06110",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.7410233,
              -72.7215689
            ],
            "instagram": "https://www.instagram.com/pulsetattoo/"
          },
          {
            "company": "Queso Ink Gallery Tattoo & Piercing",
            "site": "",
            "address": "Mintal Gym, San Francisco St, Tugbok",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Davao City, Davao del Sur",
            "name": "",
            "playvideo": "",
            "latLng": [
              7.0926246,
              125.5001774
            ],
            "instagram": "https://www.instagram.com/quesoinkgallery/"
          },
          {
            "company": "Razorblade PRO Wholesale Tattoo, Piercing, & Medical Supplies",
            "site": "https://razorblade.pro/",
            "address": "22 N Cameron St, ",
            "zip": "17101",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Harrisburg, Pennsylvania 17101",
            "name": "",
            "playvideo": "",
            "latLng": [
              40.2651237,
              -76.8777908
            ],
            "instagram": "https://www.instagram.com/razorbladepro/"
          },
          {
            "company": "Red Dragon Tattoo Supply",
            "site": "https://www.reddragontattoosupply.com/",
            "address": "6110 Powers Ave #7",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Jacksonville, FL 32217",
            "name": "",
            "playvideo": "",
            "latLng": [
              30.2612765,
              -81.6235394
            ],
            "instagram": "https://www.instagram.com/reddragontattoosupply/"
          },
          {
            "company": "Redline Tattoo Supply",
            "site": "https://www.dovmemalzemelerim.com/",
            "address": "Gen\u00e7lik Mahallesi I\u015f\u0131klar Caddesi 47/A Muratpa\u015fa, Antalya",
            "zip": "",
            "region": "Asia",
            "country": "Turkey",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/tk.svg?v=1727386595",
            "state": " ",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.7482443,
              33.6844224
            ],
            "instagram": "https://www.instagram.com/redlinetattoosupply/reels/?hl=en"
          },
          {
            "company": "Rockstar Ready Tattoo Supply",
            "site": "https://www.tattooproducts.com/",
            "address": "12331 Hampton Park Blvd",
            "zip": "33624",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Tampa, Florida 33624",
            "name": "",
            "playvideo": "",
            "latLng": [
              28.0594924,
              -82.5376744
            ],
            "instagram": "https://www.instagram.com/rockstarreadytattoosupplies/"
          },
          {
            "company": "SGOONS TATTOO",
            "site": "https://sgoonstattoosupply.com/",
            "address": "Unit 36 (G/F), Century Plaza Complex, Juana Osme\u00f1a Street, Cebu City",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Cebu",
            "name": "",
            "playvideo": "",
            "latLng": [
              10.3114841,
              123.892032
            ],
            "instagram": "https://www.instagram.com/sgoonstattoosupplyph/?hl=en"
          },
          {
            "company": "Sinners Tattoo Studio and Supply",
            "site": "https://www.sinnerstattoostudio.com/",
            "address": "5000 Rowlett Rd Suite 110",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Rowlett, Texas 75088",
            "name": "",
            "playvideo": "",
            "latLng": [
              32.9055441,
              -96.5715241
            ],
            "instagram": "https://www.instagram.com/sinners_tattoostudio/"
          },
          {
            "company": "Sinners Tattoo Studio and Supply",
            "site": "https://www.sinnerstattoostudio.com/",
            "address": "5032 Lemmon Ave Suite B, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Dallas, Texas 75209",
            "name": "",
            "playvideo": "",
            "latLng": [
              32.8240873,
              -96.8217698
            ],
            "instagram": "https://www.instagram.com/sinners_tattoostudio/"
          },
          {
            "company": "Skull Tattoo Supply",
            "site": "",
            "address": "Cl. 48l Sur #5g-25",
            "zip": "",
            "region": "South America",
            "country": "Colombia",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/co.svg?v=1722505025",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              4.5557823,
              -74.1138235
            ],
            "instagram": "https://www.instagram.com/skulltattoosupply/"
          },
          {
            "company": "SOULFLOWER CAUSE",
            "site": "https://soulflower.mx/",
            "address": "Calzada Independencia Sur #30",
            "zip": "44360",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Jalisco",
            "name": "",
            "playvideo": "",
            "latLng": [
              20.6762758,
              -103.3441199
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER COUNTESS",
            "site": "https://soulflower.mx/",
            "address": "Tamaulipas #104 Second Floor",
            "zip": "6140",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Del. Cuauht\u00e9moc",
            "name": "",
            "playvideo": "",
            "latLng": [
              19.4105112,
              -99.1795467
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER HIDALGO",
            "site": "https://soulflower.mx/",
            "address": "Miguel Hidalgo y Costilla 811, Zona Centro, 44200 Guadalajara, Jal., ",
            "zip": "44200",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Jalisco",
            "name": "",
            "playvideo": "",
            "latLng": [
              20.6769851,
              -103.3581123
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER LEON",
            "site": "https://soulflower.mx/",
            "address": "Blvd. Vicente Valtierra #99",
            "zip": "37190",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Esquina",
            "name": "",
            "playvideo": "",
            "latLng": [
              21.1351817,
              -101.6826482
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER MERIDA",
            "site": "https://soulflower.mx/",
            "address": "Prolongation of Paseo Montejo #396",
            "zip": "97129",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "",
            "name": "",
            "playvideo": "",
            "latLng": [
              20.9886229,
              -89.6195944
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER MONTERREY",
            "site": "https://soulflower.mx/",
            "address": "Padre Mier y Pino Su\u00e1rez 734, Local 9, 64000 Monterrey, N.L.,",
            "zip": "64100",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Nuevo Le\u00f3n",
            "name": "",
            "playvideo": "",
            "latLng": [
              25.6689285,
              -100.3232755
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER PEACE",
            "site": "https://soulflower.mx/",
            "address": "Baja Mar shopping mall Calle 5 de Mayo #15, local PB 1",
            "zip": "23000",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Baja California",
            "name": "",
            "playvideo": "",
            "latLng": [
              24.1632781,
              -110.3174821
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER PUEBLA",
            "site": "https://soulflower.mx/",
            "address": "C. Tlaxco 316, La Paz, 72160 Heroica Puebla de Zaragoza, Pue.,",
            "zip": "72160",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Puebla",
            "name": "",
            "playvideo": "",
            "latLng": [
              19.6724918,
              -99.1822457
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "SOULFLOWER REP. FROM ARGENTINA",
            "site": "https://soulflower.mx/",
            "address": "Republic of Argentina #42, Local 3D",
            "zip": "6000",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": " Del. Cuauht\u00e9moc",
            "name": "",
            "playvideo": "",
            "latLng": [
              19.4105101,
              -99.1976196
            ],
            "instagram": "https://www.instagram.com/soulflowermx/"
          },
          {
            "company": "Starr Tattoo Supplies",
            "site": "https://starrtattoo.com/",
            "address": "Unit 1 Meir Rd, Redditch B98 7SY",
            "zip": "B98 7SY",
            "region": "Europe",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg?v=1722500404",
            "state": "Stoke-on-Trent ST3 7HX, UK",
            "name": "",
            "playvideo": "",
            "latLng": [
              52.9793422,
              -2.1245075
            ],
            "instagram": "https://www.instagram.com/starrtattoosupplies/"
          },
          {
            "company": "Steadfast Tattoo Co",
            "site": "https://steadfasttattooco.com/",
            "address": "7433 pacific ave",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Tacoma, Washington 98408",
            "name": "",
            "playvideo": "",
            "latLng": [
              47.1888291,
              -122.4381891
            ],
            "instagram": "https://www.instagram.com/steadfasttattoosupply"
          },
          {
            "company": "T-PRO Tattoo Supply",
            "site": "https://www.tprotattoo.com/",
            "address": "12155 Magnolia Ave STE 6B",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Riverside, CA 92503",
            "name": "",
            "playvideo": "",
            "latLng": [
              33.8938974,
              -117.4999622
            ],
            "instagram": "https://www.instagram.com/tprotattoosupply/"
          },
          {
            "company": "TATSoul Tattoo Supply",
            "site": "https://www.tatsoul.com/",
            "address": "1300 John Reed Ct",
            "zip": "91745",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "City of Industry, CA",
            "name": "",
            "playvideo": "",
            "latLng": [
              34.000872,
              -117.9454355
            ],
            "instagram": "https://www.instagram.com/tatsoul/"
          },
          {
            "company": "Tattoo Everything Supplies",
            "site": "http://www.tattooeverythingsupplies.co.uk",
            "address": "Unit 2 Lever Grove",
            "zip": "BL2 1EZ",
            "region": "United Kingdom",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg?v=1722500404",
            "state": "Bolton, UK",
            "name": "",
            "playvideo": "",
            "latLng": [
              53.5712733,
              -2.4235834
            ],
            "instagram": "https://www.instagram.com/salon3000_minsk/"
          },
          {
            "company": "Tattoo Express Supply",
            "site": "https://tattooexpresssupply.com/",
            "address": "29300 Kohoutek Way unit 170, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Union City, California 94587",
            "name": "",
            "playvideo": "",
            "latLng": [
              37.6093534,
              -122.0842545
            ],
            "instagram": "https://www.instagram.com/tattooexpresssupply/"
          },
          {
            "company": "Tattoo Salon 3000",
            "site": "https://salon3000.com/",
            "address": "prasp. Niezalie\u017enasci 91, Minsk, Minskaja voblas\u0107 220012",
            "zip": "220012",
            "region": "Europe",
            "country": "Belarus",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/by.svg?v=1722491738",
            "state": "Minsk, Minskaja voblas\u0107, ",
            "name": "",
            "playvideo": "",
            "latLng": [
              53.9238362,
              27.6076743
            ],
            "instagram": "https://www.instagram.com/salon3000_minsk/"
          },
          {
            "company": "Double H Tattoo Supply",
            "site": "https://www.doublehtattoo.com/",
            "address": "98-1025 Moanalua Rd",
            "zip": "96701",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Aiea, Hawaii",
            "name": "",
            "playvideo": "",
            "latLng": [
              21.3855569,
              -157.9447728
            ],
            "instagram": "https://www.instagram.com/double_h_tattoo_supply/"
          },
          {
            "company": "Tattoo Supply Panama",
            "site": "https://www.tattoosupplypanama.com/",
            "address": "Edificio Samil, V\u00eda Argentina PB, Panam\u00e1, Provincia de Panam\u00e1, Panama",
            "zip": "",
            "region": "Central America",
            "country": "Panama",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/panama.svg?v=1723525400",
            "state": "Provincia de Panam\u00e1",
            "name": "",
            "playvideo": "",
            "latLng": [
              8.9888112,
              -79.5284461
            ],
            "instagram": "https://www.instagram.com/tattoosupplypanama"
          },
          {
            "company": "Tattoo Supply Tijuana",
            "site": "",
            "address": "Av Constituci\u00f3n 1308, Zona Centro, 22000 Tijuana, B.C.,",
            "zip": "",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": " ",
            "name": "",
            "playvideo": "",
            "latLng": [
              32.5301188,
              -117.040124
            ],
            "instagram": "https://www.instagram.com/tattoosupplytijuana/"
          },
          {
            "company": "Tatualogic",
            "site": "",
            "address": "Via Antonio Pacinotti, 72 90145 ",
            "zip": "",
            "region": "AsiEuropea",
            "country": "Italy",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/it.svg?v=1723188157",
            "state": "Palermo",
            "name": "",
            "playvideo": "",
            "latLng": [
              38.1280349,
              13.3336231
            ]
          },
          {
            "company": "The Needle Parlor",
            "site": "https://theneedleparlor.com/",
            "address": "1000 W Cienega Ave, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "San Dimas, California 91773",
            "name": "",
            "playvideo": "",
            "latLng": [
              34.1025493,
              -117.8302545
            ],
            "instagram": "https://www.instagram.com/theneedleparlor/"
          },
          {
            "company": "TMT Tattoo Supply",
            "site": "https://dovmemalzemesi365.com/",
            "address": "Zeytinlik neighborhood Yakut street no4 Tamer passage shop no17 Bakirkoy",
            "zip": "",
            "region": "Asia",
            "country": "Turkey",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/tu.svg?v=1723188226",
            "state": "Istanbul",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.0358979,
              28.980665
            ],
            "instagram": "https://www.instagram.com/tmttattoosupply/?hl=en"
          },
          {
            "company": "Tommy Supplies",
            "site": "https://www.tommyssupplies.com/",
            "address": "34 Egypt Rd unit a",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Somers, Connecticut 06071",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.9630871,
              -72.4629633
            ],
            "instagram": "https://www.instagram.com/tommyssupplies/"
          },
          {
            "company": "TOP TATTOO STUDIO AND SUPPLY",
            "site": "https://www.instagram.com/toptattoossupply/?hl=en",
            "address": "C. Salvador Cucurullo 61",
            "zip": "51000",
            "region": "Caribbean Islands",
            "country": "Dominican Republic",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/dr.svg?v=1722499815",
            "state": "Santiago de los Caballeros",
            "name": "",
            "playvideo": "",
            "latLng": [
              19.4539421,
              -70.7070118
            ],
            "instagram": "https://www.instagram.com/toptattoossupply/?hl=en"
          },
          {
            "company": "TSS Tatouage",
            "site": "https://tattoostocksupplies.com/",
            "address": "272 Rue Judaïque, 33000",
            "zip": "",
            "region": "Europe",
            "country": "France",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/fr.svg",
            "state": "Lyon",
            "name": "",
            "playvideo": "",
            "latLng": [
              45.7651851,
              4.825966
            ],
            "instagram": "https://www.instagram.com/ultimatetattoosupply/"
          },          {
            "company": "TSS Tatouage",
            "site": "https://tattoostocksupplies.com/",
            "address": "4 Rue François Vernay, 69005 ",
            "zip": "",
            "region": "Europe",
            "country": "France",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/fr.svg",
            "state": "Lyon",
            "name": "",
            "playvideo": "",
            "latLng": [
              45.7651851,
              4.825966
            ],
            "instagram": "https://www.instagram.com/ultimatetattoosupply/"
          },
          {
            "company": "Ultimate Tattoo Supply",
            "site": "https://ultimatetattoosupply.com/",
            "address": "7410 Coca-Cola Drive Suite 107, ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Hanover, Maryland 21076",
            "name": "",
            "playvideo": "",
            "latLng": [
              35.0970827,
              -80.9508216
            ],
            "instagram": "https://www.instagram.com/ultimatetattoosupply/"
          },
          {
            "company": "Unimax Supply Co Inc",
            "site": "https://store.unimaxshop.com/storefront.aspx",
            "address": "269 Canal Street floor 2, ",
            "zip": "10013",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "New York, New York 10013",
            "name": "",
            "playvideo": "",
            "latLng": [
              40.7191268,
              -74.0035874
            ],
            "instagram": "https://www.instagram.com/unimaxtattoosupply/"
          },
          {
            "company": "Vulcan Needles",
            "site": "https://www.libertytattoosupply.com/",
            "address": "2300 Westinghouse Blvd Ste 110 ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Raleigh, North Carolina 27604",
            "name": "",
            "playvideo": "",
            "latLng": [
              35.8106451,
              -78.5982126
            ],
            "instagram": "https://www.instagram.com/vulcanneedles/?hl=en"
          },
          {
            "company": "Vulcan Needles",
            "site": "https://www.libertytattoosupply.com/",
            "address": "4048 Flowers Road Ste 210 ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Atlanta, Georgia 30360",
            "name": "",
            "playvideo": "",
            "latLng": [
              33.9098185,
              -84.2848114
            ],
            "instagram": "https://www.instagram.com/vulcanneedles/?hl=en"
          },
          {
            "company": "Vulcan Needles",
            "site": "https://www.libertytattoosupply.com/",
            "address": "2025 Louisville Rd Suite C ",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg",
            "state": "Savannah, Georgia 31415",
            "name": "",
            "playvideo": "",
            "latLng": [
              32.0822674,
              -81.1279358
            ],
            "instagram": "https://www.instagram.com/vulcanneedles/?hl=en"
          },
          {
            "company": "Wholesale Body Jewelery",
            "site": "https://wholesalebodyjewellery.com/",
            "address": "19 Factory Rd",
            "zip": "BH16 5SN",
            "region": "Europe",
            "country": "United Kingdom",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg?v=1722500404",
            "state": "Poole, UK",
            "name": "",
            "playvideo": "",
            "latLng": [
              50.7345894,
              -2.0242898
            ],
            "instagram": "https://www.instagram.com/wholesalebodyjewellery/"
          },
          {
            "company": "WorldWide Tattoo Supply",
            "site": "https://www.worldwidetattoo.com/english/",
            "address": "15410 Stafford St",
            "zip": "91744",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "City of Industry, California 91744",
            "name": "",
            "playvideo": "",
            "latLng": [
              34.0254286,
              -117.9634452
            ],
            "instagram": "https://www.instagram.com/worldwidetattoo/"
          },
          {
            "company": "ZhibSGoons Tattoo Supply",
            "site": "",
            "address": "304 Orchard Rd, #02-46 Lucky Plaza",
            "zip": "",
            "region": "Asia",
            "country": "Philippines",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/ph.svg?v=1722499279",
            "state": "Singapore",
            "name": "",
            "playvideo": "",
            "latLng": [
              1.3044162,
              103.8313985
            ]
          },
          {
            "company": "Lucky Supply",
            "site": "https://luckysupplyusa.com/",
            "address": "12141 62nd St N #1, ",
            "zip": "",
            "region": "USA",
            "country": "USA",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Largo, Florida 33773",
            "name": "",
            "playvideo": "",
            "latLng": [
              27.8823122,
              -82.7224938
            ],
            "instagram": "https://www.instagram.com/luckysupplyusa"   
          },
          {
            "company": "Alamo Med",
            "site": "https://www.alamomed.com/",
            "address": "11815 IH 10 West Suite 100",
            "zip": "",
            "region": "USA",
            "country": "USA",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "San Antonio, Texas 78230",
            "name": "",
            "playvideo": "",
            "latLng": [
              29.5519915,
              -98.5878355
            ],
            "instagram": "https://www.instagram.com/alamo.medical.distributors/"
          },
           {
            "company": "Agma Tattoo Supply",
            "site": "https://agmatattoo.com/",
            "address": "Viad. Javier Rojo Gómez 1019, Cubitos, ",
            "zip": "",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Pachuca de Soto - 42090, Hgo.,",
            "name": "",
            "playvideo": "",
            "latLng": [
              20.1146295,
              -98.7396031
            ],
            "instagram": "https://www.instagram.com/agma_tattoo_supply/"
          },
          {
  "company": "Wasp Tattoo Supply",
  "site": "https://www.dovmemalzemeler.com/",
  "address": "Meşrutiyet Mah. Selanik Cad. 50 / 4",
  "zip": "06420",
  "region": "Europe",
  "country": "Turkey",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/tu.svg?v=1723188226",
  "state": "Çankaya / Ankara",
  "name": "",
  "playvideo": "",
  "latLng": [39.921886, 32.855316],
  "instagram": "https://www.instagram.com/wasptattoosupply/"
},
{
  "company": "Eagle Tattoo Supply",
  "site": "https://eagletattoosupply.com/",
  "address": "Viad. Pdte. Miguel Alemán Valdés 173, entre Isabel la Católica y 5 de febrero, Álamos, Benito Juárez",
  "zip": "03400",
  "region": "Mexico",
  "country": "Mexico",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
  "state": "Mexico City",
  "name": "",
  "playvideo": "",
  "latLng": [19.3979, -99.1572],
  "instagram": ""
},
{
  "company": "Saviour Tattoo Supplies",
  "site": "https://www.saviourtattoosupplies.co.uk/",
  "address": "Unit 5, Crown Industrial Estate, Poland Street",
  "zip": "M4 6BN",
  "region": "Europe",
  "country": "UK",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uk.svg?v=1722500404",
  "state": "Manchester, England",
  "name": "",
  "playvideo": "",
  "latLng": [53.487126, -2.225553],
  "instagram": "https://www.instagram.com/saviourtattoosupplies/"
},
{
  "company": "Body Graphics Tattoo Supply",
  "site": "https://www.bodygraphicstattoosupply.co.za/",
  "address": "Northlands Business Park, 157 Speculator Ave, Hoogland",
  "zip": "2169",
  "region": "Africa",
  "country": "South Africa",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/south_africa.png?v=1771907686",
  "state": "Johannesburg, Gauteng",
  "name": "",
  "playvideo": "",
  "latLng": [-25.9875, 27.9654],
  "instagram": ""
},
{
  "company": "Brett Stewart Tattoo Supplies",
  "site": "https://www.bstattoo.com.au/",
  "address": "20-22 Rodney Rd",
  "zip": "3215",
  "region": "Australia",
  "country": "Australia",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/aus.png?v=1739821511",
  "state": "North Geelong, VIC",
  "name": "",
  "playvideo": "",
  "latLng": [-38.1095, 144.3540],
  "instagram": ""
},
{
  "company": "Redline Tattoo Supply",
  "site": "https://www.dovmemalzemelerim.com/",
  "address": "Gençlik Mah. Işıklar Cad. Cankatan Apt. 23/A",
  "zip": "07100",
  "region": "Europe",
  "country": "Turkey",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/tu.svg?v=1723188226",
  "state": "Muratpaşa / Antalya",
  "name": "",
  "playvideo": "",
  "latLng": [36.8868, 30.7000],
  "instagram": ""
},
{
  "company": "Arte Sano Tattoo Supplies",
  "site": "https://artesanotattoosupplies.com/es/",
  "address": "San Nicolás de Olabeaga, 12 Lonja, Basurtu-Zorrotza",
  "zip": "48013",
  "region": "Europe",
  "country": "Spain",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/spa.svg",
  "state": "Bilbao, Bizkaia",
  "name": "",
  "playvideo": "",
  "latLng": [43.2625, -2.9451],
  "instagram": ""
},
{
  "company": "VegaTattoo Supplies",
  "site": "https://www.vegatattoosupplies.com/",
  "address": "Calle de los Huertos Familiares, 10",
  "zip": "03349",
  "region": "Europe",
  "country": "Spain",
  "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/spa.svg",
  "state": "San Isidro, Alicante",
  "name": "",
  "playvideo": "",
  "latLng": [38.0617, -0.8294],
  "instagram": ""
},
          {
            "company": "Tempel Tattoo Insumoss ",
            "site": " ",
            "address": "Rondeau 1394 esquina Colonia, ",
            "zip": "",
            "region": "South America",
            "country": "Uruguay",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/uruguay.png?v=1752189411",
            "state": "Montevideo",
            "name": "",
            "playvideo": "",
            "latLng": [
              -34.9050569,
              -56.1913455
            ],
            "instagram": "https://www.instagram.com/tempeltattooinsumoss/"  
           },
             {
            "company": "Tattoo Mata",
            "site": "https://tattoomata.mx",
            "address": "Perif. Blvd. Manuel Ávila Camacho 61, Hab Viveros de la Loma ",
            "zip": "54080",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Tlalnepantla",
            "name": "",
            "playvideo": "",
            "latLng": [
              19.5243164,
              -99.2259365
            ],
            "instagram": "https://www.instagram.com/tattoomata.mx/?hl=es"
          },
          {
            "company": "Asian Tattoo Supply",
            "site": "http://www.asiantattoosupply.com/",
            "address": "Wong Chuk Yeung Street 1, Yue Cheung Centre 4/F K",
            "zip": "",
            "region": "Asia",
            "country": "Hong Kong",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/hk.svg?v=1722501670",
            "state": "Fotan",
            "name": "",
            "playvideo": "",
            "latLng": [
              22.3970269,
              114.1905407
            ],
            "instagram": "https://www.instagram.com/asiantattoosupply/"
          },
          {
            "company": "Beehive Worldwide Distro",
            "site": "https://beehiveworldwidedistro.com/",
            "address": "3539 Washington Blvd",
            "zip": "84403",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Ogden, UT",
            "name": "",
            "playvideo": "",
            "latLng": [
              41.1988804,
              -111.9713223
            ],
            "instagram": "https://www.instagram.com/beehiveworldwidedistro/"
          },
          {
            "company": "Cream Tattoo Supply",
            "site": "https://creamtattoosupply.com/",
            "address": "102 Prospect St",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Indianapolis, IN",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.7520743,
              -86.1542355
            ],
            "instagram": "https://www.instagram.com/creamtattoosupply/"
          },
          {
            "company": "Jester Tattoo Supply",
            "site": "https://jestertattoos.com/",
            "address": "Abingdon, Maryland",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Abingdon, MD",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.4699639,
              -76.3050537
            ],
            "instagram": "https://www.instagram.com/theejesterstattoo/"
          },
          {
            "company": "Keystone Tattoo Supply",
            "site": "https://keystonetattoosupply.com/",
            "address": "833 Lincoln Ave Unit 5",
            "zip": "19380",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "West Chester, PA",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.9744135,
              -75.5932336
            ],
            "instagram": "https://www.instagram.com/keystonetattoosupply/"
          },
          {
            "company": "Orange Peel Tattoo Supply",
            "site": "https://orangepeeltattoosupply.com/",
            "address": "2190 Fairbanks Ave Unit B",
            "zip": "32789",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Winter Park, FL",
            "name": "",
            "playvideo": "",
            "latLng": [
              28.5928361,
              -81.378979
            ],
            "instagram": "https://www.instagram.com/orangepeeltattoosupply/"
          },
          {
            "company": "Pro Source Tattoo Supply",
            "site": "https://prosourcetattoosupply.myshopify.com/",
            "address": "17330 E 9 Mile Rd",
            "zip": "48021",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Eastpointe, MI",
            "name": "",
            "playvideo": "",
            "latLng": [
              42.4646758,
              -82.9428875
            ],
            "instagram": ""
          },
          {
            "company": "Reyes Tattoo Supply",
            "site": "https://www.reyestattoosupply.com/",
            "address": "Av. Tepeyac 930 Chapalita",
            "zip": "45040",
            "region": "Mexico",
            "country": "Mexico",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/mx.svg?v=1722501670",
            "state": "Zapopan, Jalisco",
            "name": "",
            "playvideo": "",
            "latLng": [
              20.6629027,
              -103.4039721
            ],
            "instagram": "https://www.instagram.com/reyestattoosupply/"
          },
          {
            "company": "Solid State Tattoo Supply",
            "site": "https://solidstatetattoosupply.com/",
            "address": "Denver, Colorado",
            "zip": "",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Denver, CO",
            "name": "",
            "playvideo": "",
            "latLng": [
              39.7451998,
              -104.9921849
            ],
            "instagram": "https://www.instagram.com/solidstatetattoosupply/"
          },
          {
            "company": "Steadfast Tattoo Supply",
            "site": "https://steadfasttattooco.com/",
            "address": "7433 Pacific Ave",
            "zip": "98408",
            "region": "USA",
            "country": "United States",
            "flag": "https://cdn.shopify.com/s/files/1/0607/6248/8905/files/us.svg?v=1722484843",
            "state": "Tacoma, WA",
            "name": "",
            "playvideo": "",
            "latLng": [
              47.1889573,
              -122.4338267
            ],
            "instagram": "https://www.instagram.com/steadfasttattoosupply/"
          }

        ]
      }